import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BASE_URL } from "./Config";
import axios from "axios";
import Cookies from "js-cookie";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // 👁️ Eye icons
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Register() {
  const [status, setStatus] = useState("");
  const [statustype, setStatustype] = useState(""); // "success" or "err"
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const location = useLocation();

  const { number, CountryCode, insert_id } = location.state || {};

  const [UserIp, setUserIP] = useState("");

  const getUserIP = async () => {
    try {
      const res = await axios.get("https://api.ipify.org?format=json");

      setUserIP(res.data.ip);

      return res.data.ip;
    } catch (err) {
      console.error("IP fetch error", err);
      return null;
    }
  };

  useEffect(() => {
    const userId = Cookies.get("user_id");
    if (userId) {
      navigate("/");
    }

    getUserIP();
  }, [navigate]);

  useEffect(() => {
    if (!number || !CountryCode || !insert_id) {
      navigate("/register-number");
    }
  }, [navigate, number, CountryCode]);

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    number: number, // ✅ pre-fill from state
    CountryCode: CountryCode,
    pending_registerd_id: insert_id, // ✅ pre-fill from state
    agreed: false,
    user_ip: UserIp,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.username) {
      setStatus("❌ User Name Required");
      setStatustype("err");
      return resetError();
    }

    if (formData.password.length < 5) {
      setStatus("❌ Password must be at least 5 characters");
      setStatustype("err");
      return resetError();
    }

    if (formData.password !== formData.confirmPassword) {
      setStatus("❌ Password Not Matched");
      setStatustype("err");
      return resetError();
    }

    if (!formData.agreed) {
      setStatus("❌ Please agree to terms & conditions");
      setStatustype("err");
      return resetError();
    }

    setLoading(true);

    try {
      // ✅ Prepare payload (exclude empty email if not entered)
      const payload = { ...formData };
      if (!payload.email) {
        delete payload.email;
      }

      const response = await fetch(`${BASE_URL}/user_register.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log(result);

      if (result.success) {
        setStatus("✅ Registered Successfully!");
        setStatustype("success");

        // ✅ reset but keep number & CountryCode
        setFormData({
          username: "",
          email: "",
          password: "",
          confirmPassword: "",
          number: formData.number,
          CountryCode: formData.CountryCode,
          agreed: false,
          user_ip: UserIp,
        });

        Cookies.set("user_id", result.user_id);
        Cookies.set("username", result.username); // FIXED
        Cookies.set("token", result.token);

        navigate("/", { replace: true, state: {} });
      } else {
        setStatus("❌ " + result.message);
        setStatustype("err");

        // 🚀 redirect to OTP if user not found
        if (result.message.includes("User not found")) {
          setTimeout(() => {
            navigate("/verify-phone");
          }, 3000);
        }
      }
    } catch (error) {
      console.error("Registration error:", error);
      setStatus("❌ Something went wrong!");
      setStatustype("err");
    }

    setLoading(false);
  };

  // helper to clear error messages
  const resetError = () => {
    setTimeout(() => {
      setStatus("");
      setStatustype("");
    }, 5000);
  };

  return (
    <>
      <div className="container pb-5">
        <div className="row">
          <div className="col-12 pt-5">
            <div className="logo">
              <Link to="/">
                <img
                  src={`${BASE_URL}/images/fastrade_logo.jpg`}
                  style={{ width: "220px" }}
                  alt="Fast Trade "
                />
              </Link>
            </div>
          </div>

          <div className="col-12 pt-4 login_alert ">
            <div className="status-massage">
              <p className={statustype}> {status}</p>
            </div>

            <div className="login-form">
              <form onSubmit={handleSubmit}>
                <div className="form-page">
                  <h2>Personal Account</h2>
                  <div className="inputs pt-3">
                    <input
                      type="text"
                      placeholder="Username"
                      className="number_input"
                      value={formData.username}
                      onChange={(e) =>
                        setFormData({ ...formData, username: e.target.value })
                      }
                    />
                    <input
                      type="email"
                      placeholder="Email (Optional)"
                      className="number_input"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                    />

                    {/* Password Field with Eye */}
                    <div style={{ position: "relative" }}>
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="New Password"
                        className="number_input"
                        value={formData.password}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            password: e.target.value,
                          })
                        }
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: "15px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#555",
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>

                    {/* Confirm Password Field with Eye */}
                    <div style={{ position: "relative", marginTop: "15px" }}>
                      <input
                        type={showConfirm ? "text" : "password"}
                        placeholder="Confirm Password"
                        className="number_input"
                        value={formData.confirmPassword}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            confirmPassword: e.target.value,
                          })
                        }
                      />
                      <span
                        onClick={() => setShowConfirm(!showConfirm)}
                        style={{
                          position: "absolute",
                          right: "15px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#555",
                        }}
                      >
                        {showConfirm ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>

                  <div className="remeber pt-3">
                    <input
                      type="checkbox"
                      checked={formData.agreed}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          agreed: e.target.checked,
                        })
                      }
                    />
                    <p style={{ margin: "0" }}>
                      <b>
                        I agree to the{" "}
                        <Link to="/terms-condition" className="redirect_link">
                          Terms and Conditions
                        </Link>
                      </b>
                    </p>
                  </div>

                  <div className="submit-btn pt-3">
                    <input
                      type="submit"
                      value={loading ? "Registering..." : "Register"}
                      className="btn btn-primary"
                      style={{
                        width: "100%",
                        backgroundColor: "#128DE5",
                        padding: "10px",
                        marginBottom: "15px",
                        fontWeight: "600",
                      }}
                      disabled={loading}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
